import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import InstallationEdit from '@/ui/pages/InstallationEdit/InstallationEdit';

// HS-1633: the create form, prefilled, with the fields the installation's status locks.
export const Route = createFileRoute('/_dashboard/installations/$id/edit')({
  beforeLoad: requireRoute('/installations/$id/edit'),
  component: InstallationEdit,
});
